import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be3a0d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Consulte as ofertas disponíveis ")
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ion-text-center b4" }, [
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("*alguns descontos somente para loja física")
], -1))
const _hoisted_4 = { class: "b5" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Conteúdo Digital ")
const _hoisted_6 = {
  class: "ion-text-center font-poppins-extra bg-tabloide",
  size: "12"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Hoje não temos nenhum tabloide disponível ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_PinchScrollZoom = _resolveComponent("PinchScrollZoom")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_thumbnail = _resolveComponent("ion-thumbnail")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.isOpenRef,
        header: "Ativação",
        "sub-header": "Important message",
        message: "Ativado com sucesso",
        buttons: ['OK'],
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpen
      }, {
        default: _withCtx(() => [
          _createVNode(_component_SafeArea, {
            onOnBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeTabloide(false))),
            data: {'cart': false}
          }),
          _createVNode(_component_ion_content, null, {
            default: _withCtx(() => [
              _createVNode(_component_PinchScrollZoom, {
                ref: "zoomer",
                width: 600,
                height: 800,
                scale: 1,
                originX: 0,
                originY: 0,
                translateX: 0,
                translateY: 0,
                within: false,
                enableDragging: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        style: {"white-space":"pre-line"},
                        class: "ion-text-center",
                        size: "8"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.tabloideDescricao.descricao), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createElementVNode("img", {
                    class: "img-text",
                    src: _ctx.tabloideImagem
                  }, null, 8, _hoisted_1)
                ]),
                _: 1
              }, 512)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open"]),
      _createVNode(_component_ion_modal, {
        ref: "modal",
        trigger: "open-modal",
        "is-open": _ctx.isOpenAtivacao,
        "initial-breakpoint": 0.60,
        breakpoints: [0, 0.65]
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_content, { class: "ion-padding" }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper, {
                pagination: true,
                modules: _ctx.modules,
                autoplay: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_swiper_slide, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b1",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, { icon: _ctx.iconTab }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center b2",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modules"]),
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["is-open", "initial-breakpoint", "breakpoints"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[2] || (_cache[2] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, {
        scrollX: "true",
        scrollY: "true"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-30 layout_blue"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_4, [
                    _createVNode(_component_ion_icon, { icon: _ctx.iconTab }, null, 8, ["icon"])
                  ]),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabloides, (tabloide, index) => {
                return (_openBlock(), _createBlock(_component_ion_col, {
                  class: "ion-text-center",
                  key: index,
                  size: "12"
                }, {
                  default: _withCtx(() => [
                    (tabloide.nomeoferta == ' ')
                      ? (_openBlock(), _createBlock(_component_ion_row, {
                          key: 0,
                          class: "ion-align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_col, { size: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_col, { size: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_skeleton_text, {
                                      animated: true,
                                      style: {"width":"100%"}
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_thumbnail, { class: "ion-text-center skthumb" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_skeleton_text, { animated: true })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(tabloide.titulo), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabloide.imagens, (imagem, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        onClick: ($event: any) => (_ctx.showTabloide(imagem, tabloide))
                      }, [
                        _createElementVNode("img", {
                          class: "img-text",
                          src: imagem
                        }, null, 8, _hoisted_8)
                      ], 8, _hoisted_7))
                    }), 256))
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_ctx.tabloides.length == 0 )
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    class: "ion-text-center b5",
                    key: _ctx.index,
                    size: "12"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}